import { render, staticRenderFns } from "./departure.vue?vue&type=template&id=2e753186&scoped=true"
import script from "./departure.vue?vue&type=script&lang=js"
export * from "./departure.vue?vue&type=script&lang=js"
import style0 from "./departure.vue?vue&type=style&index=0&id=2e753186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e753186",
  null
  
)

export default component.exports